<!-- //
窗体分隔条
@auth xuyd
@date 2024-05-02
//-->
<template>
  <div class="collapse-bar position" @click="handleClick">
    <el-icon v-if="position === 'right'" :class="show? 'el-icon-arrow-right': 'el-icon-arrow-left'"/>
    <el-icon v-else :class="show? 'el-icon-arrow-left': 'el-icon-arrow-right'"/>
  </div>
</template>

<script>

export default {
  name: 'CompCollapseBar',
  data() {
    return {
      show: this.value
    }
  },
  model: {
    value: 'value',
    event: 'change',
  },
  props: {
    position: {
      type: String,
      default: 'left',
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick() {
      this.show = !this.show;
      this.$emit('change', this.show);
    }
  }

}
</script>

<style scoped lang="less">

@import '../../assets/css/variables.less';

.collapse-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 50px;
  padding: 6px 2px;
  font-size: 12px;
  cursor: pointer;
  background-color: #f1f1f1;

  &:hover {
    //color: @dv_split_active_color;
    background-color: #e1e1e1;
    font-weight: 700;
  }
}

.position {
  position: absolute;
  top: 40%;
  right: 0;
  margin-right: -10px;
  z-index: 99;
}

</style>
